import { delay } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { useNavigate } from 'react-router-dom';

import { useNavigateBlocker } from './useNavigateBlocker';

export const useNavigateBackHandler = (
  navigateBackLink: string,
  enabled: boolean = true,
) => {
  const navigate = useNavigate();
  const [showLeaveModal, setShowLeaveModal] = useState(true);

  const { state } = useNavigateBlocker(enabled && showLeaveModal);

  const handleNavigateBackWithoutBlocker = useCallback(
    (waitTime?: number) => {
      flushSync(() => {
        setShowLeaveModal(false);
      });

      const navigateBack = () => {
        navigate(
          {
            pathname: navigateBackLink,
          },
          { replace: true },
        );
      };

      delay(() => {
        navigateBack();
      }, (waitTime ?? 0.5) * 1000);
    },
    [navigate, navigateBackLink],
  );

  useEffect(() => {
    // If enabled is false, do nothing
    if (!enabled) {
      return;
    }

    // Prevent navigating back to this page
    const handleNavigation = (event: PopStateEvent) => {
      event.preventDefault();

      if (state === 'blocked') {
        navigate(navigateBackLink, {
          replace: true,
        });
      }
    };

    window.addEventListener('popstate', handleNavigation);

    return () => {
      window.removeEventListener('popstate', handleNavigation);
    };
  }, [navigate, navigateBackLink, enabled, state]);

  return {
    navigate,
    handleNavigateBackWithoutBlocker,
  };
};
